import { render, staticRenderFns } from "./ConfiguratorPaints.vue?vue&type=template&id=83ad9888&scoped=true&"
import script from "./ConfiguratorPaints.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorPaints.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorPaints.vue?vue&type=style&index=0&id=83ad9888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ad9888",
  null
  
)

export default component.exports